import { defineStore } from 'pinia';
import {
    editBusinessProcessNodeApi,
    getBusinessProcessNodeDataApi,
    getBusinessProcessCandidateApi,
    addNodeQuestionApi,
    editNodeQuestionApi,
    editAbilityScoreApi,
    addBackgroundCheckApi,
    getBackgroundCheckListApi,
    editBackgroundCheckApi,
    delNodeQuestionApi,
    getCandidateCodeApi,
    postNodeQuestionApi,
    editBusinessProcessCandidateApi,
    editArchiveApi,
    getResumeQuestionApi,
    addEvaluationApi,
    getEvaluationListApi,
    getUnstructuredQuestionsApi,
    generateUnstructuredQuestionApi,
    generateUnstructuredQuestionByQuestionApi,
    generateSummaryApi,
    getSummaryListApi,
    editSummaryApi,
    getUnstructuredQuestionsByTypeApi,
    aiUnstructuredScoreApi,
    updateRawChatApi,
    aiStructuredScoreApi,
    patchBusinessProcessNodeApi,
    patchRecordNoteApi,
    changeNodeCategoryApi,
    patchScoreApi,
    getUnstructuredQuestionsByQuestionApi,
    getUnstructuredQuestionsExamineQuestionApi,
    putProcessAbilityBatchApi,
    suggestQuestionApi,
    getChatSummaryListApi,
    getNodeReportApi,
    putNodeReportApi,
    postNodeReportApi,
    postProcessSummaryGenerateApi,
    postQuestionSuggestionApi,
    postFollowUpSuggestionApi,
    postChatSummaryApi,
    putCancelInterviewApi,
    putProcessNodeConcludeApi,
    postProcessNodeOpeningQuestionApi,
    postFollowUpSituationApi,
    postAssessmentSubPointCompletionApi,
    getAssessmentProcessSubPointGeneratingStatusApi,
    postAssessmentProcessSubPointGenerateApi,
    getNodeQuestionAnalysisApi,
    getNodeQuestionAnalysisAiStatusApi,
    retryQuestionAnalysisApi,
    retryMetricsAnalysisApi,
    retryInterviewerCommentApi,
    retryQuestionSuggestionApi,
    reanalyzeNodeQuestionAnalysisApi
} from "~/modules/my-interview/apis/interview.js"

import { MessagePlugin } from 'tdesign-vue-next';
import { mockInterviewStore } from './mock-interview-store.js';

// 面试方案-初面，复面，终面
export const interviewCourseStore = defineStore({
    id: 'interviewCourseStore',
    state: () => ({
        formatTime: '00:00:00', // 计时器时间
        openPrefill: false, // 是否打开预填信息
        isAIanalyse: false, //是否开启AI分析
        AiResultArr: [], //AI生成的问题list
        skeletonLoading: true, //骨架屏状态
        flowStepList: [], // 面试方案步骤列表
        mitNodeData: null, // 点击的流程节点id的数据
        previewNodeData: null, // 预览的流程节点id的数据
        loading: false, // 是否正在加载中-按钮
        stepContent: null, //记录哪个节点，用于查看总结
        candidateData: { // 候选人信息
            expectedHireDate: null,
            expectedSalary: null,
            resignReason: null
        },
        resumeData: null, // 简历详情
        pdfSource: null, // 简历PDF-URL
        chartLoading: false, //加载雷达图
        referenceCheckList: null, //候选人的背调人列表
        isStructure: '', // 是否是结构化面试（已废弃）
        interviewMode: null,//面试模式，resume 简历模式，structure 结构化模式，free 自由模式
        chartData: { //雷达图需要的数据
            indicator: [], // 维度
            seriesPost: [], // 岗位要求
            candidate: [], // 候选人能力
        },
        questionList: [ //问题列表
            {
                abilityTitle: '广告力',
                abilityId: '1',
                score: null,
                questionArr: [
                    {
                        name: '问题一',
                        content: '测试内容',
                        response: '测试答案'
                    },
                    {
                        name: '问题一',
                        content: '测试内容',
                        response: '测试答案'
                    },
                ]
            },
            {
                abilityTitle: '洞察力',
                abilityId: '2',
                score: null,
                questionArr: [
                    {
                        name: '问题一',
                        content: '测试内容',
                        response: '测试答案'
                    },
                ]
            },
        ],
        starLevelOption: null, // 雷达图配置
        speechList: [],
        speechFragment: '',
        radioValue: 1, // 问题库1，简历分析问题2
        resumeQuestionList: [], // 简历问题列表
        mitResumeQuestionList: [], // 选中的简历问题列表
        selectedRowKeys: [],
        selectedRowKeys2: [],
        openAddEvaluate: false, // 追加评价弹窗
        evaluationList: [], // 追评价列表
        isStructureLoading: false, // 是否是结构化面试加载状态
        isStructureBaseQuestionList: [], // 结构化基础问题列表
        isStructureStarQuestionList: [], // Star问题列表
        isStructure5WQuestionList: [], // 结构化5W问题列表
        isStructureAbilityId: '', // 结构化问题的能力ID
        isStructureParentQuestionId: '', // 结构化问题的父问题ID
        summaryList: [], // 非结构化面试总结列表（已废弃，用于其他接口）
        summaryData: { lastSummary: '', currentSummary: '' }, // 实时摘要数据对象
        concludeLoading: false, // 非结构化面试生成总结加载状态
        currentNodeIsRecording: false, // 当前节点是否在录音
        currentNodeStatus: 'not_started', // 当前节点状态
        questionList: [], // 问题列表
        interviewTotalTime: null,
        //记录当前面试的时间
        currentNodeTime: null,
        //记录当前面试录音的chunks
        chunks: [],
        //定义录音音轨
        mediaRecorder: null,
        //记录正在面试的节点的id
        isRecordingNodeId: null,
        showConclusionView: true, // 是否显示面试总结
        printing: false,
        // 录音面试中隐藏的问题ID列表
        hiddenQuestionIds: [],
        //追问问题
        suggestQuestionList: [],
        // 追问考察点列表
        suggestAbilityList: [],
        //历史问题列表
        historyQuestionList: [],
        //摘要列表
        summaryList: [],
        // 以获取的摘要次数
        summaryCount: 0,
        //获取问题建议次数
        getQuestionSuggestionCount: 0,
        currentSummaryLoading: false,
        currentSummaryFinished: true,
        anchorAbilityId: '', // 锚点能力ID
        prestrainData: [], // 预加载数据
        isExportSummary: false, // 是否导出面试总结
        skeletonRouterLoading: false, // 骨架屏加载状态
        isAssessmentProcessSubPointGeneratingLoading: false, // 是否生成考察子项加载状态
        currentItem: [], // 当前折叠面板的值
        nodeQuestionAnalysisData: {
            initialQuestionsList: [],
            followUpQuestionsList: [],
            talkRatioMap: {},
            observationsList: [],
            tagsList: [],
            suggestionsList: [],
            comment: ""
        }, // 节点问题分析数据
        nodeQuestionAnalysisAiStatus: null, // AI生成状态
    }),
    // 持久化配置
    // persist: true,
    actions: {
        /**
         * 
         */
        async editBusinessProcessNode(data) {
            const res = await editBusinessProcessNodeApi(data)
            if (res.code === 200) {
                // MessagePlugin.success('修改成功')
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            this.loading = false
            return res
        },
        /**
         * 获取预览节点信息
         */
        async getPreviewNodeData(id) {
            const res = await getBusinessProcessNodeDataApi(id)
            if (res.code === 200) {
                this.previewNodeData = res.data
            }
            return res
        },


        /**
         * 获取流程节点详情
         * @param {*} id 
         * @returns 
         */
        async getBusinessProcessNodeData(id) {
            this.starLevelOption = null
            let res = null;

            // 如果节点id小于0，则从mock数据中查找匹配的节点
            const idNum = Number(id);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                const processData = MockStore.getMockData?.();
                if (processData && processData.processNodes) {
                    // 在 processNodes 中查找匹配 id 的节点
                    const matchedNode = processData.processNodes.find(
                        node => String(node.id) === String(id)
                    );
                    if (matchedNode) {
                        res = {
                            code: 200,
                            msg: '操作成功',
                            data: matchedNode
                        };
                    } else {
                        res = {
                            code: 200,
                            msg: '操作成功',
                            data: null
                        };
                    }
                } else {
                    res = {
                        code: 200,
                        msg: '操作成功',
                        data: null
                    };
                }
            } else {
                res = await getBusinessProcessNodeDataApi(id)
            }

            if (res.code === 200) {
                this.mitNodeData = res.data
                // 获取上一节点的面试报告
                if (this.mitNodeData?.prevId) {
                    const reportRes = await this.getNodeReport(this.mitNodeData.prevId)
                    this.mitNodeData.previousSuggestion = reportRes?.data?.suggestion || null
                }
                // const reportRes = await this.getNodeReport(this.mitNodeData?.prevId)
                // this.mitNodeData.previousSuggestion = reportRes?.data?.suggestion || null
                const a = this.mitNodeData?.abilities || []
                const e = this.mitNodeData?.expAbilities || []
                e.forEach(item => {
                    item.isCheck = item.matchFlag === '1' ? true : false;
                })
                if (e && e.length > 0) {
                    for (let i = 0; i < e.length; i++) {
                        const q = e[i].questions;
                        if (q && q.length > 0) {
                            q.forEach(question => {
                                // 如果问题还没有这些属性，则添加默认值
                                if (question.activeFramework === undefined || question.activeFramework === null || question.activeFramework === '' || !question.activeFramework) {
                                    question.activeFramework = 'star'; // 默认选中STAR法则
                                }
                                if (question.frameCollapsed === undefined) {
                                    question.frameCollapsed = true; // 默认为折叠状态
                                }

                                question.loadingIsCollapsed = false; // 默认为折叠状态
                                question.isRefreshing = false;
                                question.isChangeEdit = false;
                                question.isChangeEditDescription = false;
                            });
                        }
                    }
                }
                if (a.length > 0) {
                    for (let i = 0; i < a.length; i++) {
                        const q = a[i].questions;
                        if (q && q.length > 0) {
                            q.forEach(question => {
                                // 如果问题还没有这些属性，则添加默认值
                                if (question.activeFramework === undefined || question.activeFramework === null || question.activeFramework === '' || !question.activeFramework) {
                                    question.activeFramework = 'star'; // 默认选中STAR法则
                                }
                                if (question.frameCollapsed === undefined) {
                                    question.frameCollapsed = true; // 默认为折叠状态
                                }

                                question.loadingIsCollapsed = false; // 默认为折叠状态
                                question.isRefreshing = false;
                                question.isChangeEdit = false;
                                question.isChangeEditDescription = false;
                            });
                        }
                    }
                    this.mitNodeData.abilities.forEach(item => {
                        item.noScore = false
                        if (!item.score) {
                            item.score = 0
                        }
                    })
                    this.chartData.indicator = a.map(item => {
                        return {
                            name: item.name,
                            max: 5
                        }
                    })
                    this.chartData.seriesPost = a.map(item => item.abilityLevel)
                    this.chartData.candidate = a.map(item => (item.score || 0))
                    this.starLevelOption = {
                        legend: {
                            data: ['岗位要求', '候选人能力'],
                            orient: !this.isStructure ? 'horizontal' : 'vertical',  // true时水平放置（下方），false时垂直放置（右边）
                            right: !this.isStructure ? 'auto' : '5%',              // 仅在右边显示时需要
                            top: !this.isStructure ? 'auto' : 'middle',            // 仅在右边显示时需要居中
                            bottom: !this.isStructure ? '0' : 'auto',              // 在下方显示时设置底部距离
                            left: !this.isStructure ? 'center' : 'auto',           // 在下方显示时水平居中
                            itemWidth: 9,
                            itemHeight: 9,
                            icon: 'circle',
                            textStyle: {
                                color: 'rgba(78, 89, 105, 1)',
                                fontSize: 12,
                                padding: [0, 0, 0, 4]
                            },
                            itemGap: 19
                        },
                        radar: {
                            center: ['50%', '50%'],
                            radius: '60%',
                            indicator: this.chartData.indicator,
                            splitLine: {
                                lineStyle: {
                                    color: '#E5E5E5'
                                }
                            },
                            splitArea: {
                                show: true,
                                areaStyle: {
                                    color: ['#FFFFFF']
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#E5E5E5'
                                }
                            },
                            name: {
                                textStyle: {
                                    color: 'rgba(29, 33, 41, 1)',
                                    fontSize: 12
                                }
                            }
                        },
                        series: [
                            {
                                name: '得分',
                                type: 'radar',
                                data: [
                                    {
                                        value: this.chartData.seriesPost,
                                        name: '岗位要求',
                                        symbol: 'circle',
                                        symbolSize: 4,
                                        lineStyle: {
                                            width: 1
                                        },
                                        areaStyle: {
                                            color: 'rgba(33, 204, 255, 0.2)'
                                        },
                                        itemStyle: {
                                            color: '#21CCFF'
                                        }
                                    },
                                    {
                                        value: this.chartData.candidate,
                                        name: '候选人能力',
                                        symbol: 'circle',
                                        symbolSize: 4,
                                        lineStyle: {
                                            width: 1
                                        },
                                        areaStyle: {
                                            color: 'rgba(49, 60, 169, 0.2)'
                                        },
                                        itemStyle: {
                                            color: '#313CA9'
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                    this.chartLoading = false
                }
            } else {
                this.chartLoading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },

        /**
         * 获取候选人和简历详细信息
         * @param {*} id 
         * @returns 
         */
        async getBusinessProcessCandidate(id) {
            this.candidateData = {
                expectedHireDate: null,
                expectedSalary: null,
                resignReason: null
            }
            this.resumeData = null
            // this.pdfSource = null
            if (id) {
                // 如果候选人id小于0，则直接使用mock数据（不请求接口）
                const idNum = Number(id);
                if (idNum < 0) {
                    const MockStore = mockInterviewStore();
                    const mockRes = MockStore.getMockCandidateRes?.();
                    if (mockRes && mockRes.code === 200) {
                        this.skeletonLoading = false;
                        this.isAIanalyse = false;
                        this.candidateData = mockRes.data;
                        if (this.candidateData) {
                            this.resumeData = this.candidateData.resume;
                            this.pdfSource = this.resumeData?.resumePath || null;
                            this.flowStepList.forEach(item => {
                                if (item.category === 0) {
                                    item.name = '候选人：' + this.candidateData.name;
                                }
                                //标识一下进度条的状态
                                item.stepStatus = item.nodeStatus;
                            });
                        }
                        return mockRes;
                    }
                }

                const res = await getBusinessProcessCandidateApi(id)
                if (res.code === 200) {
                    this.skeletonLoading = false
                    this.isAIanalyse = false
                    this.candidateData = res.data
                    if (this.candidateData) {
                        this.resumeData = this.candidateData.resume
                        this.pdfSource = this.resumeData?.resumePath || null
                        this.flowStepList.forEach(item => {
                            if (item.category === 0) {
                                item.name = '候选人：' + this.candidateData.name
                            }
                            //标识一下进度条的状态
                            item.stepStatus = item.nodeStatus;

                        })
                    }
                } else {
                    if (res.code !== 401) {
                        MessagePlugin.error(res.msg)
                    }
                }
                return res
            }
        },
        /**
         * 修改候选人和简历详细信息
         */
        async editBusinessProcessCandidate(data) {
            const res = await editBusinessProcessCandidateApi(data)
            return res
        },

        /**
         * 归档面试候选人进入人才库
         */
        async editArchive(data) {
            const res = await editArchiveApi(data)
            return res
        },


        /***
         * 新增问题
         */
        async addNodeQuestion(data) {
            const res = await addNodeQuestionApi(data)
            return res
        },
        /**
         * 修改问题
         */
        async editNodeQuestion(data) {
            const res = await editNodeQuestionApi(data)
            return res
        },
        /**
         * 修改问题
         */
        async delNodeQuestion(ids) {
            const res = await delNodeQuestionApi(ids)
            if (res.code === 200) {
                // MessagePlugin.success('已删除')
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 修改能力分数
         */
        async editAbilityScore(data) {
            const res = await editAbilityScoreApi(data)
            return res
        },

        /**
         * 修改节点类型
         * @param {*} data 
         * @returns 
         */
        async changeNodeCategory(nodeId, data) {
            const res = await changeNodeCategoryApi(nodeId, data)
            return res
        },

        /**
         * 新增背调
         */
        async addBackgroundCheck(data) {
            const res = await addBackgroundCheckApi(data)
            if (res.code === 200) {

            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 修改背调
         */
        async editBackgroundCheck(data) {
            const res = await editBackgroundCheckApi(data)
            if (res.code === 200) {

            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 查询背调人列表
         * @param {*} candidateId 候选人ID
         */
        async getBackgroundCheckList(candidateId) {
            const res = await getBackgroundCheckListApi(candidateId)
            if (res.code === 200) {
                this.referenceCheckList = res.rows
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 获取流程节点数据-总结用
         */
        async summarizeBusinessProcessNodeData(id) {
            // 如果节点id小于0，则从mock数据中查找匹配的节点
            const idNum = Number(id);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                const processData = MockStore.getMockData?.();
                if (processData && processData.processNodes) {
                    // 在 processNodes 中查找匹配 id 的节点
                    const matchedNode = processData.processNodes.find(
                        node => String(node.id) === String(id)
                    );
                    if (matchedNode) {
                        return {
                            code: 200,
                            msg: '操作成功',
                            data: matchedNode
                        };
                    }
                }
                // 如果没有找到匹配的节点，返回空数据
                return {
                    code: 200,
                    msg: '操作成功',
                    data: null
                };
            }

            const res = await getBusinessProcessNodeDataApi(id)
            return res
        },
        /**
         * 获取预填资料的授权码
         */
        async getCandidateCode(id) {
            const res = await getCandidateCodeApi(id)
            return res
        },
        /**
         * 批量创建问题
         */
        async postNodeQuestion(data) {
            const res = await postNodeQuestionApi(data);

            return res
        },
        /**
         * 查询简历问题列表
         * @param {*} candidateId 候选人ID
         * @returns 
         */
        async getResumeQuestion(candidateId) {
            const res = await getResumeQuestionApi(candidateId)
            if (res.code === 200) {
                this.resumeQuestionList = res.rows
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 新增补充评价
         * @param {*} data
         * @returns 
         */
        async addEvaluation(data) {
            const res = await addEvaluationApi(data)
            return res
        },
        /**
         * 查询补充评价列表
         * @param {*} nodeId 面试节点ID
         * @returns 
         */
        async getEvaluationList(nodeId) {
            if (!nodeId) {
                return
            }
            const res = await getEvaluationListApi(nodeId)
            if (res.code === 200) {
                this.evaluationList = res.rows
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        async getEvaluationCopyList(nodeId) {
            if (!nodeId) {
                return
            }
            const res = await getEvaluationListApi(nodeId)
            return res
        },

        /**
         * 查询指定节点的非结构化考察问题列表
         */
        async getUnstructuredQuestions(data) {
            this.isStructureLoading = true
            const { nodeId, starAbilityId, parentQuestionId, feedback, fiveWAbilityId } = data

            const res = await getUnstructuredQuestionsApi({
                nodeId,
                starAbilityId,
                parentQuestionId,
                feedback,
                fiveWAbilityId,
            });

            if (res && res.rows) {
                this.isStructureBaseQuestionList = (res.rows.filter(item => item.questionType === 1) || []).slice(0, 3)
                this.isStructureStarQuestionList = res.rows.filter(item => item.questionType === 2) || []
                this.isStructure5WQuestionList = (res.rows.filter(item => item.questionType === 3) || []).slice(0, 5)

                console.log('isStructureBaseQuestionList', this.isStructureBaseQuestionList)
                console.log('isStructureStarQuestionList', this.isStructureStarQuestionList)
                console.log('isStructure5WQuestionList', this.isStructure5WQuestionList)
            } else {
                this.isStructureBaseQuestionList = []
                this.isStructureStarQuestionList = []
                this.isStructure5WQuestionList = []
            }

            this.isStructureLoading = false
            return res?.rows || []
        },
        /**
         * AI生成问题
         */
        async generateUnstructuredQuestion(data) {
            const res = await generateUnstructuredQuestionApi(data)
            if (res.code === 200) {
                if (data.questionType === 1) {
                    this.isStructureBaseQuestionList = res.rows

                } else if (data.questionType === 2) {
                    this.isStructureStarQuestionList = res.rows
                } else if (data.questionType === 3) {
                    this.isStructure5WQuestionList = res.rows
                }
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 生成指定节点指定问题的非结构化考察问题列表
         */
        async generateUnstructuredQuestionByQuestion(data) {
            const res = await generateUnstructuredQuestionByQuestionApi(data)
            if (res.code === 200) {
                if (data.questionType === 1) {
                    this.isStructureBaseQuestionList = res.rows
                } else if (data.questionType === 2) {
                    this.isStructureStarQuestionList = res.rows
                } else if (data.questionType === 3) {
                    this.isStructure5WQuestionList = res.rows
                }
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         *非结构化面试生成卖面试总结
         */
        async generateUnstructuredSummary(data) {
            const res = await generateSummaryApi(data)
            if (res.code === 200) {
                this.summaryList = res.rows
            }
            return res
        },
        /**
         *查询非结构化面试的总结列表
         */
        async getSummaryList(nodeId) {
            const res = await getSummaryListApi(nodeId);
            if (res.code === 200) {
                this.summaryList = res.rows
            }
            return res
        },
        /**
         * 编辑总结
         */
        async editSummary(data) {
            const res = await editSummaryApi(data)
            if (res.code === 200) {
                // this.summaryList = res.rows
            }
            return res
        },
        /**
         * 切换问题
         */

        /**
         * 切换问题
         * @param {Object} params - 问题参数
         */
        async switchQuestion(params) {
            try {
                // 获取新问题数据
                const res = await getUnstructuredQuestionsByTypeApi({
                    nodeId: params.nodeId,
                    questionType: params.questionType,
                    starAbilityId: params.starAbilityId,
                    fiveWAbilityId: params.fiveWAbilityId,
                    parentQuestionId: params.parentQuestionId,
                    feedback: params.feedback
                })
                if (res.code === 200) {
                    if (params.questionType === 1) {
                        this.isStructureBaseQuestionList = res.rows

                    } else if (params.questionType === 2) {
                        this.isStructureStarQuestionList = res.rows
                    } else if (params.questionType === 3) {
                        this.isStructure5WQuestionList = res.rows
                    }
                } else {
                    if (res.code !== 401) {
                        MessagePlugin.error(res.msg)
                    }
                }


                return res
            } catch (error) {
                console.error('切换问题失败:', error)
                throw error
            }
        },
        /**
         * 非结构化AI打分
         */
        async aiUnstructuredScore(data) {
            const res = await aiUnstructuredScoreApi(data)
            if (res.code === 200) {
                console.log('res', res)
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 结构化
         */
        async aiStructuredScore(data) {
            const res = await aiStructuredScoreApi(data)
            if (res.code === 200) {
                console.log('res', res)
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 更新面试原始对话.
         */
        async updateRawChat(nodeId, data) {
            const res = await updateRawChatApi(nodeId, data)
            return res
        },

        /**
         * 修改面试方案节点状态
         * @param {*} data 
         * @returns 
         */
        async patchBusinessProcessNode(data) {
            const res = await patchBusinessProcessNodeApi(data)
            return res
        },

        /**
         * 面试官记录笔记
         * @param {*} data 
         * @returns 
         */
        async patchRecordNote(data) {
            const res = await patchRecordNoteApi(data)
            return res
        },
        /**
         * 批量修改流程能力分数
         * @param {*} data 
         * @returns 
         */
        async patchScore(data) {
            const res = await patchScoreApi(data)
            return res
        },
        /**
         * 查询指定节点指定问题的非结构化考察问题列表
         */
        async getUnstructuredQuestionsByQuestion({ nodeId, questionType, parentQuestionId, starAbilityId, fiveWAbilityId, feedback }) {
            const res = await getUnstructuredQuestionsByQuestionApi({
                nodeId,
                questionType,
                parentQuestionId,
                starAbilityId,
                fiveWAbilityId,
                feedback
            })
            if (res.code === 200) {
                if (questionType === 1) {
                    this.isStructureBaseQuestionList = res.rows
                } else if (questionType === 2) {
                    this.isStructureStarQuestionList = res.rows
                } else if (questionType === 3) {
                    this.isStructure5WQuestionList = res.rows
                }
                return res.rows
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 查询指定节点指定问题的非结构化考察问题列表
         */
        async getUnstructuredQuestionsExamineQuestion(questionType, parentQuestionId) {
            const res = await getUnstructuredQuestionsExamineQuestionApi(parentQuestionId)
            if (res.code === 200) {
                if (questionType === 1) {
                    this.isStructureBaseQuestionList = res.rows
                } else if (questionType === 2) {
                    this.isStructureStarQuestionList = res.rows.filter(item => item.questionType === 2)
                } else if (questionType === 3) {
                    this.isStructure5WQuestionList = res.rows.filter(item => item.questionType === 3)
                }
                return res.rows
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 批量修改流程能力
         * @param {*} data 
         * @returns 
         */
        async putProcessAbilityBatch(data) {
            const res = await putProcessAbilityBatchApi(data)
            return res
        },
        /**
         * 生成追问建议
         * @param {*} data 
         * @returns 
         */
        async suggestQuestion(data) {
            const res = await suggestQuestionApi(data)
            return res
        },
        /**
         * 查询对话总结以及追问列表
         * @param {*} nodeId 
         * @returns 
         */
        async getChatSummaryList(nodeId) {
            this.summaryData.summary = null;
            this.currentSummaryLoading = true;
            const params = {
                orderByColumn: 'createTime',
                isAsc: 'desc',
                nodeId: nodeId
            };
            // console.log(params)
            const res = await getChatSummaryListApi(params);
            if (res.code === 200) {
                this.summaryList = res?.rows
                this.summaryData.summary = this.summaryList?.[0]?.summary
                this.currentSummaryLoading = false;
            } else {
                this.currentSummaryLoading = false;
            }
            return res
        },
        /**
         * 根据节点ID查询报告
         * @param {*} nodeId 
         * @returns 
         */
        async getNodeReport(nodeId) {
            const res = await getNodeReportApi(nodeId);
            return res
        },
        /**
         * 修改面试节点报告
         * @param {*} data 
         * @returns 
         */
        async putNodeReport(data) {
            const res = await putNodeReportApi(data);
            return res
        },
        /**
         * 新增面试节点报告
         * 
         * @param {*} data 
         * @returns 
         */
        async postNodeReport(data) {
            const res = await postNodeReportApi(data);
            return res
        },
        /**
         * 取消面试
         */
        async putCancelInterview(nodeId) {
            const res = await putCancelInterviewApi(nodeId);
            return res
        },
        /**
         * 重新生成纪要
         * @param {*} nodeId 
         * @returns 
         */
        async postProcessSummaryGenerate(nodeId) {
            const res = await postProcessSummaryGenerateApi(nodeId);
            return res
        },
        /**
         * 生成追问建议 - 废弃
         * @param {*} nodeId 
         * @param {*} url 
         * @returns 
         */
        async postQuestionSuggestion(nodeId, audioUrl) {
            console.log('postQuestionSuggestion', nodeId, audioUrl);

            const res = await postQuestionSuggestionApi(nodeId, audioUrl);
            if (res.code === 200 && res.data.question) {
                console.log('res', res);

                // 累积追问建议，每次切片的建议都会被保存
                this.historyQuestionList.unshift(...this.suggestQuestionList);
                res.data.content = res.data.question;
                this.suggestQuestionList = [res.data];
                this.getQuestionSuggestionCount++;
            }
            return res
        },
        /**
         * 生成追问建议 - 废弃
         * @param {*} nodeId 
         * @param {*} audioUrl 
         * @returns 
         */
        async postFollowUpSuggestion(nodeId, audioUrl) {
            const res = await postFollowUpSuggestionApi(nodeId, audioUrl);
            if (res.code === 200 && res.data?.followUpQuestion?.question) {
                console.log('res', res);

                // 累积追问建议，每次切片的建议都会被保存
                this.historyQuestionList.unshift(...this.suggestQuestionList);
                res.data.followUpQuestion.content = res.data.followUpQuestion.question;
                res.data.followUpQuestion.nextTopic = res.data?.nextTopic || null;
                this.suggestAbilityList = res.data?.followUpAbilities;
                this.suggestQuestionList = [res.data?.followUpQuestion];
                this.getQuestionSuggestionCount++;
            }
            return res
        },
        /**
         * 30s生成追问情况
         * @param {*} nodeId 
         * @param {*} data 
         * @returns 
         */
        async postFollowUpSituation(nodeId, data) {
            const res = await postFollowUpSituationApi(nodeId, data);
            /**
             * 返回格式：
             * {
             * code: 200，
             * msg: '',
             * data:{
             * strategy: '', // "FOLLOW_UP:顺势追问" | "GAP_CHECK:漏点补全" | "NEW_TOPIC:话题切换",
             * question: '', // 问题内容
             * assessmentPoint: '', //具体的考察点名称字符串 OR null
             * }
             * }
             */
            if (res.code === 200 && res.data) {
                console.log('res', res);
                if (res?.data?.strategy && res?.data?.strategy !== 'NEW_TOPIC' && res?.data?.question) {
                    // 累积追问建议，每次切片的建议都会被保存
                    if (this.historyQuestionList.length > 0) {
                        const mitObj = this.historyQuestionList.filter(item => item.question === res.data.question)
                        if (mitObj.length <= 0) {
                            this.historyQuestionList.unshift(...this.suggestQuestionList);
                        }
                    } else {
                        this.historyQuestionList.unshift(...this.suggestQuestionList);
                    }
                    this.suggestQuestionList = [res.data];
                    this.getQuestionSuggestionCount++;
                } else if (res?.data?.strategy && res?.data?.strategy === 'NEW_TOPIC') {
                    if (res?.data?.assessment_point) {
                        let found = false;
                        const targetId = res?.data?.assessment_point?.id;

                        // 先在 abilities 中查找
                        for (const item of this.mitNodeData?.abilities || []) {
                            if (item.id === targetId) {
                                res.data.question = item?.questions?.[0]?.content || '未识别到问题';
                                found = true;
                                break;
                            }
                        }

                        // 如果在 abilities 中没找到，再在 assessmentSubPoints 中查找
                        if (!found) {
                            for (const item of this.mitNodeData?.abilities || []) {
                                const subPoints = item.assessmentSubPoints || [];
                                for (const subItem of subPoints) {
                                    if (subItem.id === targetId) {
                                        res.data.question = subItem?.questions?.[0]?.content || '未识别到问题';
                                        found = true;
                                        break;
                                    }
                                }
                                if (found) break;
                            }
                        }
                    }
                    this.historyQuestionList.unshift(...this.suggestQuestionList);
                    this.suggestQuestionList = [res.data];
                    this.getQuestionSuggestionCount++;
                }
            }
            return res
        },
        /**
         * 60s生成考察维度的完成情况
         * @param {*} nodeId 
         * @param {*} data 
         * @returns 
         */
        async postAssessmentSubPointCompletion(nodeId, data) {
            const res = await postAssessmentSubPointCompletionApi(nodeId, data);
            if (res.code === 200 && res.data) {
                const arr = res.data
                arr.forEach(item => {
                    const subPoints = item.assessmentSubPoints || []

                    // 判断是否有 assessmentStatus 为 1 的项
                    const hasProgress = subPoints.some(subItem => subItem.assessmentStatus === 1)

                    // 判断是否所有项的 assessmentStatus 都为 2
                    const allInspected = subPoints.length > 0 && subPoints.every(subItem => subItem.assessmentStatus === 2)

                    // 判断是否所有项的 assessmentStatus 都为 0
                    const allUninspected = subPoints.length > 0 && subPoints.every(subItem => subItem.assessmentStatus === 0)

                    if (hasProgress) {
                        item.isClear = 'progress'
                    } else if (allInspected) {
                        item.isClear = 'inspect'
                    } else if (allUninspected) {
                        item.isClear = 'uninspect'
                    } else {
                        item.isClear = 'progress' // 默认值
                    }

                })
                // arr重新排序，将isClear为"inspect"的对象，排在数组后面
                arr.sort((a, b) => {
                    if (a.isClear === 'inspect') {
                        return 1
                    } else {
                        return -1
                    }
                })
                // arr重新排序，将isClear为"progress"的对象，排在数组前面
                arr.sort((a, b) => {
                    if (a.isClear === 'progress') {
                        return -1
                    } else {
                        return 1
                    }
                })
                // 从this.currentItem中删除arr中对象isClear为"inspect"的所对应的id
                this.currentItem = this.currentItem.filter(item => !arr.some(subItem => subItem.isClear === 'inspect' && subItem.id === item))
                this.suggestAbilityList = arr
            }
            return res
        },
        /**
         * 生成对话摘要
         */
        async postChatSummary(nodeId, audioUrl) {
            const res = await postChatSummaryApi(nodeId, audioUrl);
            return res
        },
        /**
         * putProcessNodeConcludeApi
         */
        async putProcessNodeConclude(data) {
            const res = await putProcessNodeConcludeApi(data);
            return res
        },

        /**
         * 生成面试开场提问
         * @param {*} nodeId 
         * @returns 
         */
        async postProcessNodeOpeningQuestion(nodeId) {
            const res = await postProcessNodeOpeningQuestionApi(nodeId);
            return res
        },

        /**
         * 查询节点生成考察子项的状态
         * @param {*} nodeId 
         * @returns 
         */
        async getAssessmentProcessSubPointGeneratingStatus(nodeId) {
            const res = await getAssessmentProcessSubPointGeneratingStatusApi(nodeId);
            return res
        },

        /**
         * 生成考察子项
         * @param {*} data 
         * @returns 
         */
        async postAssessmentProcessSubPointGenerate(data) {
            const res = await postAssessmentProcessSubPointGenerateApi(data);
            return res
        },

        /**
         * 查询节点问题分析
         * @param {*} nodeId 
         * @returns 
         */
        async getNodeQuestionAnalysis(nodeId) {
            // 如果节点id小于0，则从mock数据中获取
            const idNum = Number(nodeId);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                const res = MockStore.getMockNodeQuestionAnalysis?.(nodeId) || {
                    code: 200,
                    msg: '操作成功',
                    data: null
                };
                if (res.code === 200 && res.data) {
                    this.nodeQuestionAnalysisData = res.data;
                }
                return res;
            }
            const res = await getNodeQuestionAnalysisApi(nodeId);
            if (res.code === 200) {
                this.nodeQuestionAnalysisData = res.data;
            }
            return res
        },

        /**
         * 根据节点ID查询所有AI生成状态（用于前端轮询）
         * @param {*} nodeId 
         * @returns 
         */
        async getNodeQuestionAnalysisAiStatus(nodeId) {
            // 如果节点id小于0，则从mock数据中获取
            const idNum = Number(nodeId);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                return MockStore.getMockNodeQuestionAnalysisAiStatus?.(nodeId) || {
                    code: 200,
                    msg: '操作成功',
                    data: {
                        interviewerComment: 1,
                        questionSuggestion: 1,
                        metricsAnalysis: 1,
                        questionAnalysis: 1
                    }
                };
            }
            const res = await getNodeQuestionAnalysisAiStatusApi(nodeId);
            return res
        },

        /**
         * 重试AI问题分析
         * @param {*} nodeId 
         * @returns 
         */
        async retryQuestionAnalysis(nodeId) {
            const res = await retryQuestionAnalysisApi(nodeId);
            return res
        },

        /**
         * 重试AI指标分析
         * @param {*} nodeId 
         * @returns 
         */
        async retryMetricsAnalysis(nodeId) {
            const res = await retryMetricsAnalysisApi(nodeId);
            return res
        },

        /**
         * 重试AI面试官点评
         * @param {*} nodeId 
         * @returns 
         */
        async retryInterviewerComment(nodeId) {
            const res = await retryInterviewerCommentApi(nodeId);
            return res
        },

        /**
         * 重试AI提问建议
         * @param {*} nodeId 
         * @returns 
         */
        async retryQuestionSuggestion(nodeId) {
            const res = await retryQuestionSuggestionApi(nodeId);
            return res
        },

        /**
         * 重新分析面试提问
         * @param {*} nodeId 
         * @returns 
         */
        async reanalyzeNodeQuestionAnalysis(nodeId) {
            const res = await reanalyzeNodeQuestionAnalysisApi(nodeId);
            return res
        },

        /**
         * 清理面试相关状态
         * 在面试结束后调用，重置所有面试相关的状态变量
         */
        cleanupInterviewState() {
            // 清理录音相关状态
            this.currentNodeIsRecording = false;
            this.currentNodeStatus = 'not_started';
            this.isRecordingNodeId = null;
            this.isRecordingProcessId = null;

            // 清理录音数据
            this.chunks = [];
            this.mediaRecorder = null;

            // 清理时间记录
            this.currentNodeTime = null;

            // 清理问题列表
            this.suggestQuestionList = [];
            this.historyQuestionList = [];
            this.hiddenQuestionIds = [];
            this.summaryCount = 0;

            // 清理本地存储
            localStorage.removeItem('recordingStatus');

            console.log('[InterviewCourseStore] 面试状态已清理');
        }
    },
});
